/** Eigene Illustrationen (kein Bilddienst, keine Fremdbilder): Landschaft im Erzgebirge und drei Symbole. */

const ICON = { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true } as const;

export function LeafIcon() {
  return (
    <svg {...ICON}>
      <circle cx="32" cy="32" r="27" />
      <path d="M18 40 C18 22 30 14 46 14 C46 32 38 44 22 44 Z" />
      <path d="M18 46 C26 36 32 30 40 22" />
    </svg>
  );
}

/** Standort-Pin, dessen Körper aus einem Punktraster besteht: digital und regional. */
export function PinGridIcon() {
  const dots: [number, number][] = [];
  for (const [y, xs] of [[22, [26, 32, 38]], [28, [23, 29, 35, 41]], [34, [26, 32, 38]], [40, [29, 35]]] as [number, number[]][]) for (const x of xs) dots.push([x, y]);
  return (
    <svg {...ICON}>
      <path d="M32 6 C20 6 13 15 13 25 C13 40 32 58 32 58 C32 58 51 40 51 25 C51 15 44 6 32 6Z" />
      {dots.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="1.8" fill="currentColor" stroke="none" />
      ))}
    </svg>
  );
}

export function ToolIcon() {
  return (
    <svg {...ICON}>
      <circle cx="32" cy="32" r="27" />
      <path d="M40 17 C34 16 29 21 31 27 L19 39 C17 41 17 44 19 46 C21 48 24 48 26 46 L38 34 C44 36 49 31 48 25 L43 30 L38 26 L43 21Z" />
    </svg>
  );
}

/** Deutschlandflagge als eigene Zeichnung (schwarz, rot, gold). */
export function GermanFlag() {
  return (
    <svg className="de-flag" viewBox="0 0 30 20" role="img" aria-label="Flagge von Deutschland">
      <rect width="30" height="20" fill="#000" />
      <rect y="6.67" width="30" height="6.67" fill="#dd0000" />
      <rect y="13.33" width="30" height="6.67" fill="#ffce00" />
    </svg>
  );
}

export function RegionBadges() {
  const items = [
    { img: "pc-fotos", alt: "Fotos eines Auftrags, sortiert im Projektordner", title: "Nachhaltig arbeiten", text: "Weniger Papier, weniger Fahrten zurück ins Büro, weniger Suchen. Fotos und Nachweise sind sofort am richtigen Ort." },
    { img: "handy-fotos", alt: "Fotos im Ordner in der HandVero-Web-App auf dem Handy", title: "Digital und regional", text: "Server in Deutschland, Sitz im Erzgebirge. Sie sprechen mit Menschen, die Ihren Alltag kennen." },
    { img: "pc-protokoll", alt: "Abgeschlossenes Prüfprotokoll im Projekt", title: "Aus dem Handwerk", text: "Gebaut für Betriebe, die lieber arbeiten als verwalten. Einfach genug für den Einsatz mit Arbeitshandschuhen." },
  ];
  return (
    <>
      <div className="region-badges">
        {items.map((b) => (
          <div className="region-badge reveal" key={b.title}>
            <img className="region-photo" src={`/screens/${b.img}.jpg`} alt={b.alt} loading="lazy" decoding="async" />
            <h3>{b.title}</h3>
            <p>{b.text}</p>
          </div>
        ))}
      </div>
      <div className="de-band reveal">
        <GermanFlag />
        <div>
          <h3>Made in Germany. Ihre Daten bleiben hier.</h3>
          <ul>
            <li>Server in Deutschland, kein US-Clouddienst für Ihre Daten (nur der E-Mail-Versand läuft über Microsoft in der EU)</li>
            <li>Keine Werbe-Tracker, keine externen Schriften</li>
            <li>Jede Firma sieht nur ihre eigenen Daten</li>
            <li>Anmeldung nur mit bestätigter E-Mail-Adresse</li>
          </ul>
        </div>
      </div>
    </>
  );
}
